import React, { useEffect, useMemo, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import NoDataFound from '../../../partials/NoDataFound'
import GroupedBarChart from '../../../partials/GroupedBarChart'
import { getPaletteColor } from '../../../partials/chartTheme'
import { FormControlLabel, Radio } from '@mui/material'
import { contractorScopeConfig } from '../../../../_helpers/contractorScope'


function Index(props) {

    const [state, setState] = useState({
        loading: true,
        data: {
            dates: [],
            contractors: []
        },
        summary: false,
    })

    useEffect(() => {
        loadData()
    }, [])

    const dates = state.data.dates || []
    const contractors = state.data.contractors || []

    const labels = useMemo(() => dates.map(d => d.label), [dates])

    const series = useMemo(() => {

        // обобщена
        if (state.summary) {
            return [
                {
                    name: trans('random.reservationsCount'),
                    color1: getPaletteColor(0).color1,
                    color2: getPaletteColor(0).color2,
                    data: dates.map(d => d.total || 0),
                }
            ]
        }

        // по месеци
        return contractors.map((c, i) => ({
            name: c.name,
            color1: getPaletteColor(i).color1,
            color2: getPaletteColor(i).color2,
            data: dates.map(d => c.dates[d.date]?.total || 0),
        }))

    }, [dates, contractors, state.summary])

    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true
        }))

        Api.get('contractors/stats/reservations/total', contractorScopeConfig())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data
                }))
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })

    }

    const toggleSummaryData = val => {
        setState(prev => ({
            ...prev,
            summary: val
        }))
    }

    return (
        <div className='pannel'>
            <div className="filter-standard">
                <div className="col" data-id="4" style={{ justifyContent: 'center' }}>
                    <div style={{ display: 'flex' }}>
                        <div className="col">
                            <FormControlLabel
                                control={
                                    <Radio
                                        name='summary'

                                    />
                                }
                                checked={!state.summary}
                                onChange={() => toggleSummaryData(false)}
                                label={trans('random.inDetail')}
                            />
                        </div>
                        <div className="col">
                            <FormControlLabel
                                control={
                                    <Radio
                                        name='summary'

                                    />
                                }
                                checked={state.summary}
                                onChange={() => toggleSummaryData(true)}
                                label={trans('random.summarized')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div
                className="chart"
                style={{ padding: '10px', background: '#fff' }}
            >
                {state.loading
                    ?
                    <Skeleton height={360} />
                    :
                    contractors.length === 0
                        ?
                        <NoDataFound />
                        :
                        <>
                            <ul
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '15px',
                                    listStyle: 'none',
                                    margin: 0,
                                    padding: 0,
                                }}
                            >
                                {series.map((s, i) =>
                                    <li
                                        key={i}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            color: '#615e83',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span
                                            style={{
                                                width: '12px',
                                                height: '12px',
                                                borderRadius: '50%',
                                                flexShrink: 0,
                                                backgroundColor: s.color1,
                                            }}
                                        />
                                        {s.name}
                                    </li>
                                )}
                            </ul>
                            <GroupedBarChart
                                labels={labels}
                                series={series}
                                roundedBottom
                            />
                        </>
                }
            </div>
        </div>

    )
}

export default Index
